export const MEETING_REDUCER_KEYS = {
  REDUCER: 'meetings',
  BY_ID: 'byID',
  ITEMS_SET_BY_ID: 'itemsSetById',
  TEAMS_TAB_BY_ID: 'teamsTabById',
  SELECTED: 'selected',
}
